<template>
    <div class="popup confirm-popup visible" id="confirm-delete-check-list" @click.stop="">
        <div class="confirm-icon">
            <img :src="require('Assets/confirm-icon.svg')" width="104" height="104" alt="" />
        </div>
        <p>{{confirmAction.text}}</p>
        <div v-if="!loading && !complete" class="btns-box">
            <a href @click.stop.prevent="confirmClick" class="btn transparent">Да, удалить</a>
            <a href @click.stop.prevent="$emit('close')" class="btn js-trigger-close-popup">Нет, я ошибся</a>
        </div>
        <pre-loader-component v-else :visible="loading" :small="true"></pre-loader-component>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'
    import PreLoaderComponent from "./PreLoader";

    export default {
        name: 'confirm-component',
        components: {PreLoaderComponent},
        props: {
        },
        data() {
          return {
              loading: false,
              complete: false
          }
        },
        computed: {
            ...mapState({
                confirmAction: state => state.confirmAction
            })
        },
        methods: {
            ...mapMutations([
                'setConfirmAction'
            ]),
            confirmClick() {
                this.loading = true;
                this.$store.dispatch(this.confirmAction.action, this.confirmAction.payload).then(() => {
                    this.loading = false;
                    this.complete = true;
                    this.$emit('close');
                    this.setConfirmAction({action: '', payload: null})
                }).catch(() => {
                    console.log('Error');
                })
            }
        },
    }
</script>


<style scoped>

</style>
